import type React from "react";

import { useTranslation } from "react-i18next";

import { useGetPhysicianUnhandledPatient } from "api/hooks/useGetPhysicianUnhandledPatient";
import { Container, Notifications, TableHeader, Title } from "shared/molecules/MUIDataGrid/MUIDataGrid";

import { PhysicianMedicalReferralItem } from "./components/PhysicianMedicalReferralItem";
import { PlanOfCareItem } from "./components/PlanOfCareItem";

interface Props {
  patientId: number;
}

export const PhysicianToDoTable: React.FC<Props> = ({ patientId }) => {
  const { t } = useTranslation();

  const { data, isLoading: isLoadingPhysicianUnhandledPatient, isError } = useGetPhysicianUnhandledPatient(patientId);
  const { medical_referral_status, plan_of_care_status, first_evaluation, medical_referral_id, plan_of_care_id } =
    data || {};

  const pendingReferral = medical_referral_status === "pending";
  const pendingPlanOfCare = plan_of_care_status === "pending";
  const totalLength = [pendingReferral, pendingPlanOfCare].filter(Boolean).length;

  if (!data || isError) {
    return null;
  }

  return (
    <>
      {!isLoadingPhysicianUnhandledPatient && (
        <Container>
          <TableHeader>
            <Title>{t("dashboard.tables.physician_todo.title")}</Title>
            {totalLength > 0 && <Notifications>{totalLength}</Notifications>}
          </TableHeader>
          <PlanOfCareItem
            patientId={patientId}
            planOfCareId={plan_of_care_id}
            date={first_evaluation}
            status={plan_of_care_status || "pending"}
          />
          <PhysicianMedicalReferralItem
            patientId={patientId}
            medicalReferralId={medical_referral_id}
            date={first_evaluation}
            status={medical_referral_status || "pending"}
          />
        </Container>
      )}
    </>
  );
};
